import React from 'react'
import MenuDropdownIcon from '../../icons/menuDropdown'

import assetsPath from '../../../../common/utils/assetsPath'

import styles from './envatoProducts.module.css'

export default ({envatoProducts, envatoProductsStaticLinks}) => {
  return (
    <li className={styles.itemWithDropdown}>
      <a href='#' className={styles.link}>
        <MenuDropdownIcon className={styles.icon}
          width='16px' height='16px' />
        <span className={styles.text}>
          Our Products
        </span>
      </a>

      <div className={styles.dropdownContainer}>
        <div className={styles.dropdown}>
          <ul className={styles.dropdownList}>
            {
              envatoProducts.map((product) => {
                const productLogoPath = assetsPath() + product.logo
                return (
                  <li key={product.key}>
                    <a href={product.url}
                      className={styles.dropdownLink}
                      target='_blank'>
                      <img className={styles.logo}
                        src={productLogoPath}
                        alt={product.name} />
                      {
                        product.description
                        ? (<span className={styles.dropdownText}>
                          {product.description}
                        </span>) : null
                       }
                    </a>
                  </li>
                )
              })
            }
          </ul>

          <div className={styles.footer}>
            <ul>
              {
                envatoProductsStaticLinks.map((link) => {
                  return (
                    <li key={link.key}
                      className={styles.footerItem}>
                      {link.label}
                      <a href={link.url}
                        className={styles.footerLink}
                        target='_blank'>
                        {link.linkLabel}
                      </a>
                    </li>
                  )
                })
              }
            </ul>
          </div>
        </div>
      </div>
    </li>
  )
}



// WEBPACK FOOTER //
// ./client/components/siteHeader/header/envatoProducts.js